import ConfirmationDialog from '@client/components/ConfirmationDialog';
import moment from 'moment-timezone';
import { TIME_ZONES } from '@drayalliance/types';

import './style.css';
import { useFlags } from 'launchdarkly-react-client-sdk';

interface InvalidDate {
  id: string;
  field: string;
  invalidDate: string;
}

interface Props {
  onConfirm: () => void;
  onCancel: () => void;
  invalidDates: InvalidDate[];
}

const baseClassName = 'save-dispatch-confirmation-dialog';
const titleClassName = `${baseClassName}__title`;
const subheadingClassName = `${baseClassName}__subheading`;

function formatDate(date: string, showTimezones: boolean, timezone?: TIME_ZONES) {
  return moment(date)
    .tz(timezone || TIME_ZONES.AMERICA_LOS_ANGELES)
    .format(`MM-DD-YYYY HH:mm${showTimezones ? ' z' : ''}`);
}

function makeKey(id: string, field: string) {
  return `${id} ${field}`;
}

function buildInvalidDateDialogMessage(invalidDates: InvalidDate[], showTimezones: boolean) {
  return (
    <div>
      {invalidDates.map(({ id, field, invalidDate }) => (
          <div key={makeKey(id, field)}>
            {field} ({formatDate(invalidDate, showTimezones)}) is too far away from today.
          </div>
        ))}
    </div>
  );
}

function buildDialogMessage(invalidDates: InvalidDate[], showTimezones: boolean) {
  return (
    <div className={baseClassName}>
      <div className={titleClassName}>Date Confirmation</div>
      <div className={subheadingClassName}>Are you sure the following dates are correct?</div>
      {buildInvalidDateDialogMessage(invalidDates, showTimezones)}
    </div>
  );
}

export default function DateConfirmationDialog({ onConfirm, onCancel, invalidDates }: Props) {
  const { showTimezones } = useFlags();

  return (
    <ConfirmationDialog
      message={buildDialogMessage(invalidDates, showTimezones)}
      onCancel={onCancel}
      onConfirm={onConfirm}
      removeConfirmCheckbox
    />
  );
}
